module.exports = __webpack_public_path__ + "images/help/icon-twr59@2x-3e5068095663e01ca1d6caabdd7e01c4.png";